export interface ICommitment {
  code: string;
  hours: null|number;
}

export class Commitment {
  public code: string;
  public hours: null|number;

  constructor(data: ICommitment) {
    this.code = data.code;
    this.hours = data.hours;
  }
}
